import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Content, Loader, Message, MessageBox } from '../styles';
import { ImgContainer } from './styles';
import DeliveryStatus from '../../DeliveryStatus';
import LastErrorMessage from '../../LastErrorMessage';
import Avatar from '../../Avatar';
import ErrorMessage from '../../ErrorMessage';
import { BASE_URL } from '../../../../../config';

const Sticker = ({ client, message, resend, customerDataStoreTimezone, more = null }) => {
  return (
    <Message isClient={client} key={message?._id?.$oid + message?.sendId}>
      <Content>
        <MessageBox>
          {!message?.isClient && message?.lastSendError && (
            <IconButton aria-label="resend" onClick={() => resend(message?._id?.$oid)}>
              <RefreshIcon fontSize="small" />
            </IconButton>
          )}
          {(!message?.delivery ||
            message?.delivery === 'sending' ||
            message?.delivery === 'sent2api' ||
            message?.delivery === 'sent_to_api') &&
            !client && <Loader color="primary" src={'/img/loader-new.gif'} />}
          <ImgContainer>
            <Avatar message={message} isClient={client} />
            {message?.body?.sticker?.url ? (
              <img
                src={(message?.provider === 'whatsapp' ? BASE_URL : '') + message?.body?.sticker?.url}
                style={{ maxWidth: 400, maxHeight: 400 }}
                alt={message?.body?.sticker?.text || ''}
              />
            ) : (
              ''
            )}
          </ImgContainer>
        </MessageBox>
        {more}
        <DeliveryStatus
          isClient={client}
          message={message}
          customerDataStoreTimezone={customerDataStoreTimezone}
        />
        <LastErrorMessage message={message} />
        <ErrorMessage message={message?.rawResponse?.process_msg ?? ''} />
      </Content>
    </Message>
  );
};

export default Sticker;
